import { Music } from "lucide-react";

import "../Styles/Card.css";

/**
 * Omslaget i ett flödeskort.
 *
 * Servern härleder albumCover ur AudD:s song_link, och den saknas ofta —
 * för låtar som känts igen via fingerprint eller Spotify finns ingen
 * song_link alls. Tidigare ritades då ingenting, och kortet fick ett tomt
 * hål där bilden skulle ha suttit. Nu står en not där i stället, så raden
 * håller sin form oavsett.
 */
type Props = {
  src?: string | null;
  alt?: string;
};

export default function TrackCover({ src, alt = "" }: Props) {
  if (src) {
    return <img className="card-cover" src={src} alt={alt} />;
  }

  return (
    <div className="card-cover card-cover--empty" aria-hidden="true">
      <Music size={22} strokeWidth={1.8} />
    </div>
  );
}
